import Resource from './common/resource';

class Pages extends Resource {
  path = 'pages';
}

export default Pages;
